import 'twin.macro'

import ApplePayIcon from 'assets/icons/ApplePayIcon'
import GarminPayIcon from 'assets/icons/GarminPayIcon'
import GooglePayIcon from 'assets/icons/GooglePayIcon'
import SamsungPay from 'assets/icons/SamsungPay'
import SubTitle from 'components/UI/sub-title/sub-title'
import Title from 'components/UI/title/title'
import { ThemeContext } from 'contexts/theme-context'
import { useDeviceInfo } from 'hooks/useDeviceInfo'
import React, { useContext } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import tw from 'twin.macro'

import OrangeEllips from './../../../assets/images/benefits-container-1-gradient-ellips.webp'
import OrangeEllipsDark from './../../../assets/images/benefits-container-1-gradient-ellips-dark.webp'
import BlueGradient from './../../../assets/images/benefits-container-2-blue-gradient_3x.webp'
import CardImg from './../../../assets/images/benefits-container-2-card.webp'
import CardImgDark from './../../../assets/images/benefits-container-2-card-dark.webp'
import LightNominalImg from './../../../assets/images/benefits-container-3-nominal.webp'
import DarkNominalImg from './../../../assets/images/benefits-container-3-nominal-dark.webp'
import PocketImg from './../../../assets/images/benefits-container-3-pocket.webp'
import YellowGradient from './../../../assets/images/benefits-container-3-yellow-ellips.webp'
import GreenGradient from './../../../assets/images/benefits-container-5-green-gradient.webp'
import CartImg from './../../../assets/images/benefits-container-cart-img.webp'

function Benefits() {
  const { t } = useTranslation()
  const { isMobile } = useDeviceInfo()
  const { theme } = useContext(ThemeContext)

  return (
    <div>
      <p tw='sm:text-[48px] text-[32px] font-bold'>{t('benefits.title', { ns: 'landing' })}</p>
      <div tw='flex sm:flex-row flex-col mt-5 gap-8'>
        <div tw='flex flex-col gap-8 w-full'>
          <div tw='bg-secondary rounded-s32 p-[24px] sm:p-[32px] relative sm:h-[441px] h-[336px] sm:w-[744px] flex flex-col gap-2 overflow-hidden'>
            <Title variant='bold'>{t('benefits.container_1.title', { ns: 'landing' })}</Title>
            <SubTitle>
              <Trans>{t('benefits.container_1.desc', { ns: 'landing' })}</Trans>
            </SubTitle>
            <img src={CartImg} alt='' width={isMobile ? 293 : 517} tw='absolute bottom-0 sm:right-0 right-8 z-10' />
            <img
              src={theme === 'dark' ? OrangeEllipsDark : OrangeEllips}
              alt=''
              width='100%'
              tw='absolute bottom-0 right-0'
            />
          </div>
          {isMobile && (
            <div tw='bg-secondary rounded-s32 p-[24px] sm:p-[32px] relative  flex flex-col gap-2 h-[331px] overflow-hidden w-full min-h-[356px]'>
              <Title variant='bold'>{t('benefits.container_2.title', { ns: 'landing' })}</Title>
              <SubTitle>
                <Trans>{t('benefits.container_2.desc', { ns: 'landing' })}</Trans>
              </SubTitle>
              <img src={theme === 'dark' ? CardImgDark : CardImg} alt='' width={240} tw='absolute bottom-0 right-16' />
              <img src={BlueGradient} alt='' width={517} tw='absolute bottom-0 right-0' />
            </div>
          )}
          <div tw='flex sm:flex-row flex-col gap-8 w-full'>
            <div tw='bg-secondary rounded-s32 p-[24px] sm:p-[32px] relative  flex flex-col gap-2 h-[331px] overflow-hidden w-full'>
              <Title variant='bold'>{t('benefits.container_3.title', { ns: 'landing' })}</Title>
              <SubTitle>
                <Trans>{t('benefits.container_3.desc', { ns: 'landing' })}</Trans>
              </SubTitle>
              <img
                src={theme === 'dark' ? DarkNominalImg : LightNominalImg}
                alt=''
                width={278}
                tw='absolute bottom-0 right-0'
              />
              <img src={OrangeEllips} alt='' width={517} tw='absolute bottom-0 right-0' />
            </div>
            <div tw='bg-secondary rounded-s32 p-[24px] sm:p-[32px] relative  flex flex-col gap-2 h-[331px] overflow-hidden w-full'>
              <Title variant='bold'>{t('benefits.container_4.title', { ns: 'landing' })}</Title>
              <SubTitle>
                <Trans>{t('benefits.container_4.desc', { ns: 'landing' })}</Trans>
              </SubTitle>
              <img src={PocketImg} alt='' width={224} tw='absolute bottom-0 right-5' />
              <img src={YellowGradient} alt='' width={517} tw='absolute bottom-0 right-0' />
            </div>
          </div>
        </div>
        <div tw='flex flex-col gap-8'>
          {!isMobile && (
            <div tw='bg-secondary rounded-s32 p-[24px] sm:p-[32px] relative  flex flex-col gap-2 h-[331px] overflow-hidden w-full min-h-[356px]'>
              <Title variant='bold'>{t('benefits.container_2.title', { ns: 'landing' })}</Title>
              <SubTitle>
                <Trans>{t('benefits.container_2.desc', { ns: 'landing' })}</Trans>
              </SubTitle>
              <img src={theme === 'dark' ? CardImgDark : CardImg} alt='' width={240} tw='absolute bottom-0 right-16' />
              <img src={BlueGradient} alt='' width={517} tw='absolute bottom-0 right-0' />
            </div>
          )}

          <div tw='bg-secondary rounded-s32 p-[24px] sm:p-[32px] relative  flex flex-col gap-2 h-[331px] overflow-hidden w-full h-full'>
            <Title variant='bold'>{t('benefits.container_5.title', { ns: 'landing' })}</Title>
            <SubTitle>
              <Trans>{t('benefits.container_5.desc', { ns: 'landing' })}</Trans>
            </SubTitle>
            <div tw='grid grid-cols-2 gap-5 mt-5'>
              <div
                css={[theme === 'dark' ? tw`bg-black-opacity30` : tw`bg-primary`]}
                tw='w-[138px] h-[85px] flex items-center justify-center rounded-xl  border border-grey'
              >
                <ApplePayIcon />
              </div>
              <div
                css={[theme === 'dark' ? tw`bg-black-opacity30` : tw`bg-primary`]}
                tw='w-[138px] h-[85px]  flex items-center justify-center rounded-xl border border-grey'
              >
                <GooglePayIcon />
              </div>
              <div
                css={[theme === 'dark' ? tw`bg-black-opacity30` : tw`bg-primary`]}
                tw='w-[138px] h-[85px] flex items-center justify-center rounded-xl border border-grey'
              >
                <SamsungPay />
              </div>
              <div
                css={[theme === 'dark' ? tw`bg-black-opacity30` : tw`bg-primary`]}
                tw='w-[138px] h-[85px]  flex items-center justify-center rounded-xl border border-grey'
              >
                <GarminPayIcon />
              </div>
            </div>
            <img src={GreenGradient} alt='' width={517} tw='absolute bottom-0 right-0' />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Benefits
